import { RefIdentifierEditContainer } from '@/components/containers/ref-identifiers/RefIdentifierEditContainer'

const RefIdentifierEditPage = () => {
    return <RefIdentifierEditContainer pageType="list" />
}

export default RefIdentifierEditPage
